import { Quill } from 'react-quill';

const Embed: any = Quill.import('blots/embed');

class CustomEmogjiBlot extends Embed {
  hoverHandler: any;
  clickHandler: any;
  mounted: boolean;
  domNode: any;

  constructor(node) {
    super(node);
    this.clickHandler = null;
    this.hoverHandler = null;
    this.mounted = false;
  }

  static create(data) {
    const node = super.create();

    // thumbnail — <span>을 사용해야 <p> 안에서 유효한 HTML이 됨 (div는 p를 깨뜨림)
    const thumbSec = document.createElement('span');
    thumbSec.className = 'ql-custom-emoji-thumbnail';

    thumbSec.style.background = `center/contain no-repeat url('${data.photoUrl}')`;
    node.appendChild(thumbSec);

    // display value
    // const denotationChar = document.createElement('span');
    // denotationChar.className = 'ql-custom-emoji-denotation-char';
    // denotationChar.innerHTML = data.denotationChar;
    // node.appendChild(denotationChar);
    // node.innerHTML += data.value;

    return CustomEmogjiBlot.setDataValues(node, data);
  }

  static setDataValues(element, data) {
    const domNode = element;
    Object.keys(data).forEach((key) => {
      domNode.dataset[key] = data[key];
    });
    domNode.setAttribute('class', 'custom-emoji');

    return domNode;
  }

  static value(domNode) {
    return domNode.dataset;
  }

  attach() {
    super.attach();

    if (!this.mounted) {
      this.mounted = true;
      this.clickHandler = this.getClickHandler();
      this.hoverHandler = this.getHoverHandler();

      this.domNode.addEventListener('click', this.clickHandler, false);
      this.domNode.addEventListener('mouseenter', this.hoverHandler, false);
    }
  }

  detach() {
    super.detach();
    this.mounted = false;
    if (this.clickHandler) {
      this.domNode.removeEventListener('click', this.clickHandler);
      this.clickHandler = null;
    }
  }

  getClickHandler() {
    return (e) => {
      const event = this.buildEvent('custom-emoji-clicked', e);
      window.dispatchEvent(event);
      e.preventDefault();
    };
  }

  getHoverHandler() {
    return (e) => {
      const event = this.buildEvent('custom-emoji-hovered', e);
      window.dispatchEvent(event);
      e.preventDefault();
    };
  }

  buildEvent(name, e) {
    const event: any = new Event(name, {
      bubbles: true,
      cancelable: true,
    });
    event.value = Object.assign({}, this.domNode.dataset);
    event.event = e;
    return event;
  }
}

CustomEmogjiBlot.blotName = 'custom-emoji';
CustomEmogjiBlot.tagName = 'span';
CustomEmogjiBlot.className = 'custom-emoji';

export default CustomEmogjiBlot;
